import Footer from "../component/Footer"
import Navbar from "../component/Navbar"
export default function Location() {
    return (
        <>
        <Navbar />
        <h1>Location </h1>
         <Footer />
        </>
    )
}